import { type ObjectValuesUnionType } from '../../../utils/typing';

import { KLRound1CollectibleIds, KLRound3CollectibleIds, KLRound2CollectibleIds } from './collectible';

export const KLRounds = Object.freeze({
  T_RED: 'T_RED', // Tribu Rouge
  T_WHITE: 'T_WHITE', // Tribu Blanche
  ORIENTATION: 'ORIENTATION', // Orientation
  POLE: 'POLE', // Poteaux
});
export type KLRound = ObjectValuesUnionType<typeof KLRounds>;

export const ObfKLRounds = Object.freeze({
  [KLRounds.T_RED]: 1,
  [KLRounds.T_WHITE]: 2,
  [KLRounds.ORIENTATION]: 3,
  [KLRounds.POLE]: 4,
});

export const ReverseObfKLRounds = Object.freeze({
  '1': KLRounds.T_RED,
  '2': KLRounds.T_WHITE,
  '3': KLRounds.ORIENTATION,
  '4': KLRounds.POLE,
});

export const RoundIdByCollectibleId = Object.freeze({
  ...KLRound1CollectibleIds.reduce((acc, curr: string) => ({ ...acc, [curr]: KLRounds.T_RED }), {}),
  ...KLRound2CollectibleIds.reduce((acc, curr: string) => ({ ...acc, [curr]: KLRounds.T_WHITE }), {}),
  ...KLRound3CollectibleIds.reduce((acc, curr: string) => ({ ...acc, [curr]: KLRounds.ORIENTATION }), {}),
});
